var LanguageFilter = React.createClass({
  propTypes: {
    searchLanguages: React.PropTypes.array.isRequired,
    selectedLanguage: React.PropTypes.string,
    onLanguageChanged: React.PropTypes.func
  },
  languageChanged(e) {
    if (this.props.onLanguageChanged) {
      this.props.onLanguageChanged(e.currentTarget.value);
    }
  },
  componentDidMount: function() {
      try {
          $('.filter__language').selectpicker('refresh');
      } catch (e) {
          //Do nothing in case bootstrap-select library is not found.
      }
  },

  render() {
    if (this.props.searchLanguages.length == 0) {
      return <span />;
    }

    return (
      <BrowseFilter title={Labels.getLabel("Languages")} filterType="filter-type__language" ariaLabel="Solution Language filter" isOpen={this.props.isOpen}>
        <select className="form-control filter__language" value={this.props.selectedLanguage} onChange={this.languageChanged}>
          {this.props.searchLanguages.map(lang => {
            return <option key={lang.key} value={lang.key}>{lang.displayValue}</option>
          })}
        </select>
      </BrowseFilter>
    )
  }
});